import React from 'react';
import { Handler } from 'ml-component-web';
import Footer from '../component/Footer';
import Header from '../component/Header';

import './page.css';

export default class PageHandler extends Handler {

    renderHandler() {
        return (
            <div>
                <Header />
                <div className="content">
                    {this.props.children}
                </div>
                <Footer />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/handler/PageHandler.js
 **/